import { BadgeColor } from '@billy/design-system'

import { QuoteListFilter } from '../enums/quoteListFilter'

export const quoteListFilterToBadgeColor: Record<QuoteListFilter, BadgeColor> = {
  [QuoteListFilter.All]: 'neutral',
  [QuoteListFilter.Draft]: 'neutral',
  [QuoteListFilter.Pending]: 'warning',
  [QuoteListFilter.Accepted]: 'success',
  [QuoteListFilter.Rejected]: 'danger',
  [QuoteListFilter.Invoiced]: 'accent',
}
